import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import FondoHeader from '../../../media/img/home/imagenFondoHome.webp';

import './headerHome.scss';

const HeaderHome = () => {
  const navigate = useNavigate();
  const lineRefs = useRef([]);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.2,
      rootMargin: '0px 0px 0px 0px',
    };

    const lineObservers = lineRefs.current.map((lineRef) => {
      if (!lineRef) return null;

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('content__title-line--visible');
            observer.unobserve(entry.target);
          }
        });
      }, observerOptions);

      observer.observe(lineRef);
      return observer;
    });

    return () => {
      lineObservers.forEach((obs) => obs?.disconnect());
    };
  }, []);

  return (
    <div>
      <div className="main-content__header">
        <div className="main-content__img-container">
          <img className="main-content__img" src={FondoHeader} alt="Wonderaly Innovations - Neuropsicología Aplicada" />
        </div>
        <div className="main-content__lineatop"></div>
        <div className="main-content__lineabottom"></div>
        <div className="main-content__text">
          <div>
            <h1 className="header-title__main-page">WONDERALY INNOVATIONS</h1>
          </div>
          <div
            ref={(el) => (lineRefs.current[0] = el)}
            className="content__title-line"
          />
          <div>
            <p className="header-subtitle__main-page">
              Neuropsicología Aplicada a las Artes y la Producción Audiovisual
            </p>
          </div>
          <div>
            <p className="header-text__main-page">
              WONDERALY INNOVATIONS es una empresa especializada en la
              integración de principios neuropsicológicos en la producción
              cinematográfica y audiovisual. Utilizando IA y Business
              Intelligence, optimizamos la calidad y eficacia de los proyectos
              creativos, mejorando el impacto emocional de las narrativas y
              potenciando el rendimiento de los equipos de producción.
            </p>
          </div>
          <button
            className="content__button header-button__main-page"
            onClick={() => navigate('/Contacto')}
          >
            Contacta
          </button>
        </div>
        <div />
      </div>
    </div>
  );
};

export default HeaderHome;
